import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import { addToast } from 'containers/Toasts/actions'

import {
  getPushNotificationError,
  getPushNotificationSuccess,
  updatePushNotificationError,
  updatePushNotificationSuccess,
} from './actions'
import { PUSH_NOTIFICATION_REQUEST, UPDATE_PUSH_NOTIFICATION } from './constants'

const getPushNotificationEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(PUSH_NOTIFICATION_REQUEST.INITIATE),
    mergeMap(() =>
      api.settings.getPushNotificationSettings().pipe(
        map((response) => getPushNotificationSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getPushNotificationError, error))),
        takeUntil(action$.pipe(ofType(PUSH_NOTIFICATION_REQUEST.CANCEL)))
      )
    )
  )

const updatePushNotificationEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_PUSH_NOTIFICATION.INITIATE),
    mergeMap(() =>
      api.settings
        .updatePushNotificationSettings(
          state$.value.settings.profileSettings.pushNotifications.data
        )
        .pipe(
          mergeMap((response) =>
            of(
              addToast({ message: 'Successfully saved!' }),
              updatePushNotificationSuccess(response)
            )
          ),
          catchError((error) => of(epicsErrorHandler(updatePushNotificationError, error))),
          takeUntil(action$.pipe(ofType(UPDATE_PUSH_NOTIFICATION.CANCEL)))
        )
    )
  )

export default combineEpics(getPushNotificationEpic, updatePushNotificationEpic)
